/* Blanc Cerise — Refonte header (desktop) : sticky annonce+header + compactage au scroll,
   suppression "Notre boutique" et wishlist (cœur), pont de survol vers le méga-menu,
   grille pleine largeur native du méga-menu + image taille fixe maîtrisée. */
(function () {
  function injectCSS() {
    if (document.getElementById('bc-header-fixes')) return;
    var st = document.createElement('style');
    st.id = 'bc-header-fixes';
    st.textContent =
      /* corrige le bug bande blanche : la section nav ne doit pas heriter du height:500px (banniere) */
      /* z-index sous le panier-tiroir (z40) pour ne pas masquer son haut */
      'html .bc-header-sticky{z-index:30 !important;}' +
      'html #shopify-section-header{height:auto !important;}' +
      'html .bc-header-sticky>.shopify-section:has(header.header){height:auto !important;}' +
      '@media (min-width:1024px){' +
      '.bc-header-sticky .header__icons span:has(.wishlist-count){display:none !important;}' +
      /* grille native pleine largeur (annule cap 1366 + flex) */
      'html .bc-header-sticky .mega-menu .container{max-width:none !important;margin:0 !important;}' +
      'html .bc-header-sticky .mega-menu .container>div{display:grid !important;gap:0 !important;}' +
      'html .bc-header-sticky .mega-menu .item-menu{width:auto !important;}' +
      'html .bc-header-sticky .mega-menu .container>div:not(:has(.item-menu ~ .item-menu)) .item-menu{width:auto !important;}' +
      'html .bc-header-sticky .mega-menu .col-span-2{grid-column:span 2 !important;margin-left:0 !important;width:auto !important;}' +
      'html .bc-header-sticky .mega-menu .col-end-7.col-span-2{grid-column:span 2 / 7 !important;}' +
      /* image : taille fixe, cohérente, plus petite (420x280, recadrée), ancrée à droite */
      'html .bc-header-sticky .mega-menu .img-responsive{display:block !important;max-width:380px !important;height:auto !important;margin-left:auto !important;}' +
      /* évite le mot/ponctuation orphelin (« ? ») */
      '.bc-header-sticky .mega-menu .item-menu a,.bc-header-sticky .mega-menu a.header__menu-item{text-wrap:pretty !important;}' +
      /* pas de trait séparateur (border du titre de colonne) */
      '.bc-header-sticky .mega-menu .header__menu-item.font-semibold,.bc-header-sticky .mega-menu .item-menu>.header__menu-item{border-left:0 !important;border-right:0 !important;}' +
      /* nav pleine hauteur : la zone de survol descend jusqu'au menu (plus de vide), bascule horizontale fluide, sans pont */
      'html .bc-header-sticky .header.header--top-center{align-content:stretch !important;}' +
      'html .bc-header-sticky .header.header--top-center>nav.header__inline-menu{align-self:stretch !important;}' +
      'html .bc-header-sticky nav.header__inline-menu>.list-menu{height:100% !important;align-items:stretch !important;}' +
      'html .bc-header-sticky nav.header__inline-menu .menuItem{height:100% !important;margin:0 !important;padding-left:9px !important;padding-right:9px !important;align-items:center !important;}' +
      '.bc-header-sticky .mega-menu{overflow:visible !important;}' +
      '}';
    (document.body || document.documentElement).appendChild(st);
  }

  function hideWishlist() {
    var icons = document.querySelector('header .header__icons');
    if (!icons) return;
    var bubble = icons.querySelector('.wishlist-count');
    var node = bubble && bubble.closest('.header__icons > *');
    if (!node) {
      Array.prototype.forEach.call(icons.children, function (el) {
        if (el.querySelector && el.querySelector('.wishlist-count')) node = el;
      });
    }
    if (node) node.style.display = 'none';
  }

  function wrapSticky() {
    if (document.querySelector('.bc-header-sticky')) return document.querySelector('.bc-header-sticky');
    var headerEl = document.querySelector('header.header');
    var headerSection = (document.querySelector('.shopify-section.section-header'))
      || (headerEl && headerEl.closest('.shopify-section'));
    if (!headerSection || !headerSection.parentNode) return null;

    var wrap = document.createElement('div');
    wrap.className = 'bc-header-sticky';

    var ann = headerSection.previousElementSibling;
    var hasAnn = ann && ann.classList && ann.classList.contains('shopify-section');

    headerSection.parentNode.insertBefore(wrap, hasAnn ? ann : headerSection);
    if (hasAnn) wrap.appendChild(ann);
    wrap.appendChild(headerSection);
    return wrap;
  }

  function hideStoreLink() {
    var icons = document.querySelector('header .header__icons');
    if (!icons) return;
    Array.prototype.forEach.call(icons.children, function (el) {
      if (el.classList && el.classList.contains('sp-right-menu')) { el.style.display = 'none'; return; }
      if (el.tagName === 'SPAN' && /boutique/i.test(el.textContent || '')) { el.style.display = 'none'; }
    });
  }

  function init() {
    injectCSS();
    var wrap = wrapSticky();
    hideStoreLink();
    hideWishlist();
    if (!wrap) return;

    /* compactage au scroll avec HYSTERESIS (deux seuils eloignes) + throttle rAF
       pour eviter le tremblement (la baisse de hauteur decale le contenu pres d'un seuil unique) */
    var compact = false, ticking = false;
    function update() {
      ticking = false;
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      var c = compact ? (y > 40) : (y > 110);
      if (c === compact) return;
      compact = c;
      wrap.classList.toggle('bc-compact', c);
    }
    function onScroll() {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();